import React, { FC } from 'react'
import { Spacer } from 'components/Utility'
import { ErrorMessage } from 'components/Error'
import { isValidStoreDeliveryBread } from 'lib/validator'
import { UseStoreDeliveryBread } from 'hooks/storeDeliveryBread/useStoreDeliveryBread'
import { StoreDefaultScheduleType } from 'types/storeDefault'

type Props = {
  description: string
  categoryId: string
  isScheduledGeneration: boolean
  isTypeDaily: boolean
  dailySchedules: StoreDefaultScheduleType[]
  isTypePreorder: boolean
  preorderSchedules: StoreDefaultScheduleType[]
  isTypeDelivery: boolean
  storeDeliveryBreadForm: UseStoreDeliveryBread
}

const DefaultEditError: FC<Props> = (props) => {
  const {
    description,
    categoryId,
    isScheduledGeneration,
    isTypeDaily,
    dailySchedules,
    isTypePreorder,
    preorderSchedules,
    isTypeDelivery,
    storeDeliveryBreadForm,
  } = props

  // 曜日選択済みか、受渡解禁時刻が指定されていてオープン時在庫数/販売上限数が1以上である
  const isValidSchedules = (schedules: StoreDefaultScheduleType[], isScheduledGeneration?: boolean): boolean => {
    return schedules.every((schedule) => {
      if (schedule.days_of_week.length > 0 || isScheduledGeneration) {
        return schedule.default_stocks.every((defaultStock) => {
          return defaultStock.pickupable_time !== '' && defaultStock.stock > 0
        })
      } else {
        return true
      }
    })
  }

  return (
    <div>
      <Spacer size={24} />
      {description === '' && (
        <>
          <ErrorMessage caution={'商品説明を入力してください。'} id={'description'} />
          <Spacer size={12} />
        </>
      )}
      {categoryId === '' && (
        <>
          <ErrorMessage caution={'商品カテゴリを選択してください。'} id={'category'} />
          <Spacer size={12} />
        </>
      )}
      {!isTypeDaily && !isTypePreorder && !isTypeDelivery && (
        <>
          <ErrorMessage caution={'注文タイプを選択してください。'} id={'order-type'} />
          <Spacer size={12} />
        </>
      )}
      {isTypeDaily && !isValidSchedules(dailySchedules, isScheduledGeneration) && (
        <>
          <ErrorMessage caution={'当日取り置きの受渡解禁時刻とオープン時在庫数を選択しください。'} id={'daily-stock'} />
          <Spacer size={12} />
        </>
      )}
      {isTypeDaily && dailySchedules.some((schedule) => schedule.choices.includes('')) && (
        <>
          <ErrorMessage
            caution={'受け渡しオプション有りを選択しているため、オプション内容を入力してください。'}
            id={'daily-choices'}
          />
          <Spacer size={12} />
        </>
      )}
      {isTypeDaily &&
        isScheduledGeneration &&
        dailySchedules.some((schedule) => schedule.days_of_week.length === 0) && (
          <>
            <ErrorMessage caution={'当日取り置きの在庫を自動で登録する曜日を選択してください。'} id={'daily-stock'} />
            <Spacer size={12} />
          </>
        )}
      {isTypePreorder && !isValidSchedules(preorderSchedules, true) && (
        <>
          <ErrorMessage caution={'事前予約の受渡解禁時刻と1日の販売上限数を選択してください。'} id={'preorder-stock'} />
          <Spacer size={12} />
        </>
      )}
      {isTypePreorder && preorderSchedules.some((schedule) => schedule.choices.includes('')) && (
        <>
          <ErrorMessage
            caution={'受け渡しオプション有りを選択しているため、オプション内容を入力してください。'}
            id={'preorder-choices'}
          />
          <Spacer size={12} />
        </>
      )}
      {isTypePreorder && preorderSchedules.some((schedule) => schedule.days_of_week.length === 0) && (
        <>
          <ErrorMessage caution={'事前予約の在庫を登録する曜日を選択してください。'} id={'preorder-stock'} />
          <Spacer size={12} />
        </>
      )}
      {isTypeDelivery && !isValidStoreDeliveryBread(storeDeliveryBreadForm) && (
        <>
          <ErrorMessage caution={'取り寄せの設定を確認してください。'} id={'delivery'} />
          <Spacer size={12} />
        </>
      )}
    </div>
  )
}

export default DefaultEditError
